import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {RestApiService} from '../../../../core/services/http/rest-api.service';
import {ApiPatientsListPaginatedQueryParams} from './api-patients-list-paginated-query-params';
import {Observable} from 'rxjs';
import {ApiPatientListResponse} from './api-patient-list-response';
import {ApiRoutesEnum} from '../../../../core/services/http/api-routes.enum';
import {ApiPatientResponse} from './api-patient-response';
import {ApiAlgoResultsResponse} from './api-algo-results-response';
import {ApiFileResponse} from './api-file-response';

@Injectable()
export class PatientRestApiService {

  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _restApiService: RestApiService,
  ) {
  }

  public requestPatientListPaginated(
    queryParams: ApiPatientsListPaginatedQueryParams,
  ): Observable<ApiPatientListResponse> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.PATIENTS,
    ].join('/');
    const params: HttpParams = this._restApiService.createHttpParams(queryParams);
    return this._httpClient.get<ApiPatientListResponse>(url, {params: params});
  }

  public requestPatient(patientId: string): Observable<ApiPatientResponse> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.PATIENTS,
      patientId,
    ].join('/');
    return this._httpClient.get<ApiPatientResponse>(url);
  }

  public requestReport(patientId: string): Observable<Blob> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.ALGOS,
      'pdf',
      patientId,
    ].join('/');
    return this._httpClient.get(url, {responseType: 'blob'});
  }

  public requestFile(fileId: string): Observable<ApiFileResponse> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.FILES,
      fileId,
    ].join('/');
    return this._httpClient.get<ApiFileResponse>(url);
  }

  public requestCaseExport(): Observable<Blob> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.CASE_EXPORT,
    ].join('/');

    return this._httpClient.get(url, {responseType: 'blob'});
  }

  public requestAlgoResults(algoResultsId: string): Observable<ApiAlgoResultsResponse> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.ALGOS_RESULTS,
      algoResultsId,
    ].join('/');
    return this._httpClient.get<ApiAlgoResultsResponse>(url);
  }
}
